export default {"src":"/_next/static/media/play.7d92139c.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};